import React from 'react';
import { GridColumnMenuProps, GridColumnMenuContainer } from '@mui/x-data-grid/components';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';

interface CustomColumnMenuProps extends GridColumnMenuProps {
  onConfigureColumns?: () => void;
}

const CustomColumnMenu: React.FC<CustomColumnMenuProps> = (props) => {
  const { onConfigureColumns, hideMenu, colDef, ...other } = props;

  const handleConfigureClick = (event: React.MouseEvent<HTMLLIElement>) => {
    hideMenu?.(event);
    onConfigureColumns?.();
  };

  return (
    <GridColumnMenuContainer hideMenu={hideMenu} colDef={colDef} {...other}>
      {/* Add our custom menu item - this is the only option */}
      <MenuItem onClick={handleConfigureClick}>
        <ListItemIcon>
          <ViewColumnIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Configure Columns</ListItemText>
      </MenuItem>
    </GridColumnMenuContainer>
  );
};

export default CustomColumnMenu;


